import styled from 'styled-components'
import { SansText } from '../SansText/SansText'
import { SizesGroup } from '../SizesGroup/SizesGroup'

export const Container = styled.div`
  position: absolute;
  top: calc(100% - 3.5rem);
  display: flex;
  width: 100%;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.2rem;
  transition: transform 300ms;
  transform: translateY(0);

  &:hover {
    transform: translateY(calc(-100% + 3.8rem));
  }
`

export const SizeGuideLink = styled(SansText)`
  text-decoration: underline;

  &:hover {
    text-decoration: underline;
  }
`

export const StyledSizesGroup = styled(SizesGroup)`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, 3.5rem);
  gap: 1rem;
  justify-content: center;
`

export const Title = styled.h3`
  font-size: 1.4rem;
  line-height: 1.7rem;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fonts.brand};
  text-transform: uppercase;
`
